import Input from "./input";
// @ts-ignore
import Textarea from "../Textarea";
import InputPassword from "./password";

Input.Textarea = Textarea;
Input.Password = InputPassword;

export default Input;
